function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "PDF_Icon_zaakceptowanu",
  transform: "translate(0 0)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_84",
  "data-name": "Path 84",
  d: "M528.335,109.472l-1.323-1.54-1.259,1.081,1.973,2.3a.83.83,0,0,0,.629.289h.013a.829.829,0,0,0,.633-.309l3.416-4.24-1.292-1.041Z",
  transform: "translate(-511.762 -85.918)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_36",
  "data-name": "Rectangle 36",
  width: 10.172,
  height: 1.223,
  transform: "translate(4.884 5.255)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_37",
  "data-name": "Rectangle 37",
  width: 10.172,
  height: 1.223,
  transform: "translate(4.884 9.584)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_38",
  "data-name": "Rectangle 38",
  width: 4.931,
  height: 1.223,
  transform: "translate(4.884 18.242)"
}), /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle_39",
  "data-name": "Rectangle 39",
  width: 10.172,
  height: 1.223,
  transform: "translate(4.884 13.913)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_85",
  "data-name": "Path 85",
  d: "M478.233,57.373a.983.983,0,0,1-.982-.983V36.48a.983.983,0,0,1,.982-.983H491.99a.983.983,0,0,1,.982.983V48.556a7.51,7.51,0,0,1,2.109.464V36.084a2.751,2.751,0,0,0-2.751-2.751H477.893a2.751,2.751,0,0,0-2.751,2.751v20.7a2.751,2.751,0,0,0,2.751,2.751h7.774a7.512,7.512,0,0,1-.716-2.164Z",
  transform: "translate(-475.142 -33.333)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_86",
  "data-name": "Path 86",
  d: "M519.644,90.857a6.874,6.874,0,1,0,6.874,6.873A6.881,6.881,0,0,0,519.644,90.857Zm0,12.087a5.214,5.214,0,1,1,5.214-5.214A5.22,5.22,0,0,1,519.644,102.944Z",
  transform: "translate(-502.369 -74.955)"
}));

var SvgAcceptedFileIcon = function SvgAcceptedFileIcon(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.149,
    height: 29.649,
    viewBox: "0 0 24.149 29.649",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgAcceptedFileIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/accepted_file_icon.fb015581.svg";
export { ForwardRef as ReactComponent };